import { Button, Col, Descriptions, Row, Tag } from 'antd';
import React from 'react';
import { handleProperty } from '../../../../../config/resourcePropertiesConfig';
import styles from '../index.less';
import { truncateString } from '@/utils/utils';
import RenderTags from './RenderTags';

const SingleResourcePropertiesData = ({ resourceProperties, provider, service }) => {
  // *resourceProperties contains tags property that should be rendered at the last of the list of properties
  const { Tags, ...restProperties } = resourceProperties;
  const tagPproperty = handleProperty(provider, service, 'Tags', Tags);
  return (
    <>
      {Object.keys(restProperties).map((key, i) => {
        const property = handleProperty(provider, service, key, restProperties[key]);
        if (property) {
          if (property.name === 'Tags') {
            return <RenderTags key={i} name={property.name} tags={property.value} />;
          } else if (typeof property.value === 'object') {
            return Object.keys(property.value).map((item, i) => {
              return <RenderExtraProperty key={i} name={item} value={property.value[item]} />;
            });
          } else {
            return <RenderProperty key={i} name={property.name} value={property.value} />;
          }
        }
      })}
      {// *  rendering tags property at the end of the list
      Tags?.length > 0 && tagPproperty && (
        <RenderTags name={tagPproperty.name} tags={tagPproperty.value} />
      )}
    </>
  );
};

export default SingleResourcePropertiesData;

const RenderProperty = ({ name, value }) => {
  return (
    <Row gutter={12} wrap={false}>
      <Col span={10}>
        <p className={styles.tagsTitle}>{name}</p>
      </Col>
      <Col span={14}>
        <p className={styles.tagsParagraph}>
          <span style={{ fontSize: '13px' }}>{value ? value : '-'}</span>
        </p>
      </Col>
    </Row>
  );
};

const RenderExtraProperty = ({ name, value }) => {
  return (
    <Row gutter={12}>
      <Col span={10}>
        <p className={styles.tagsTitle}>{name}</p>
      </Col>
      <Col span={14}>
        <p className={styles.tagsParagraph}>{value}</p>
      </Col>
    </Row>
  );
};
